/**
 * Gather the list of clipboard event types as constants.
 */
var ClipboardEventTypes = /** @class */ (function () {
    function ClipboardEventTypes() {
    }
    /**
     * The clipboard event is fired when a copy command is active (pressed).
     */
    ClipboardEventTypes.COPY = 0x01; //
    /**
     *  The clipboard event is fired when a cut command is active (pressed).
     */
    ClipboardEventTypes.CUT = 0x02;
    /**
     * The clipboard event is fired when a paste command is active (pressed).
     */
    ClipboardEventTypes.PASTE = 0x03;
    return ClipboardEventTypes;
}());
export { ClipboardEventTypes };
/**
 * This class is used to store clipboard related info for the onClipboardObservable event.
 */
var ClipboardInfo = /** @class */ (function () {
    /**
     *Creates an instance of ClipboardInfo.
     * @param type Defines the type of event (BABYLON.ClipboardEventTypes)
     * @param event Defines the related dom event
     */
    function ClipboardInfo(
    /**
     * Defines the type of event (BABYLON.ClipboardEventTypes)
     */
    type, 
    /**
     * Defines the related dom event
     */
    event) {
        this.type = type;
        this.event = event;
    }
    /**
     *  Get the clipboard event's type from the keycode.
     * @param keyCode Defines the keyCode for the current keyboard event.
     * @return {number}
     */
    ClipboardInfo.GetTypeFromCharacter = function (keyCode) {
        var charCode = keyCode;
        //TODO: add codes for extended ASCII
        switch (charCode) {
            case 67:
                return ClipboardEventTypes.COPY;
            case 86:
                return ClipboardEventTypes.PASTE;
            case 88:
                return ClipboardEventTypes.CUT;
            default:
                return -1;
        }
    };
    return ClipboardInfo;
}());
export { ClipboardInfo };
//# sourceMappingURL=clipboardEvents.js.map